import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { RelativeLinksPipe } from '@shared/pipes/relative-links.pipe';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

@Component({
  selector: 'app-ck-viewer',
  imports: [
    RelativeLinksPipe,
    SafeHtmlPipe,
  ],
  templateUrl: './ck-viewer.component.html',
  styleUrl: './ck-viewer.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CkViewerComponent implements AfterViewChecked {
  fullBody = input<boolean>(false);
  htmlDescription = input<string>('');
  private elRef: ElementRef = inject(ElementRef);

  ngAfterViewChecked() {
    this.setAnchorScrolling(this.elRef.nativeElement);
  }

  setAnchorScrolling(htmlRoot: any) {
    let elems = htmlRoot.querySelectorAll('[datа-linktype="anchor"]');
    if (!elems.length) {
      elems = htmlRoot.querySelectorAll('a[href*="#"]');
    }

    elems.forEach((elem: HTMLElement) => {
      elem.addEventListener('click', (event: Event) => {
        event.preventDefault();
        event.stopPropagation();

        const elemHref = elem.getAttribute('href');
        if (!elemHref || !elemHref.includes('#')) return;
        const targetId = elemHref.split('#')[1];
        if (!targetId) return;

        const targetElemByName = htmlRoot.querySelector(`[name="${targetId}"]`);
        const targetElemById = htmlRoot.querySelector(`[name="${targetId}"]`);

        targetElemByName?.scrollIntoView({ behavior: 'smooth' });
        targetElemById?.scrollIntoView({ behavior: 'smooth' });

      });
    });
  }

}
